import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer
      className="relative z-10 border-t py-8 mt-16"
      style={{
        backgroundColor: 'var(--background-surface)',
        borderColor: 'var(--border-color)'
      }}
    >
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Help Section */}
          <div>
            <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
              Help & Guides
            </h3>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => navigate('/faq')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                FAQ
              </button>
              <button
                onClick={() => navigate('/guide/upload-audio')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                How to Upload Audio
              </button>
              <button
                onClick={() => navigate('/guide/share-audio')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                How to Share Audio
              </button>
              <button
                onClick={() => navigate('/guide/convert-mp3')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                Convert to MP3
              </button>
            </div>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
              Legal
            </h3>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => navigate('/terms-of-service')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                Terms of Service
              </button>
              <button
                onClick={() => navigate('/privacy-policy')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                Privacy Policy
              </button>
              <button
                onClick={() => navigate('/dmca')}
                className="text-sm hover:text-soundwave-500 transition-colors text-left"
                style={{ color: 'var(--text-secondary)' }}
              >
                DMCA Policy
              </button>
            </div>
          </div>

          {/* Community Section */}
          <div>
            <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
              Community
            </h3>
            <div className="flex flex-col gap-2">
              <a
                href="/blog/"
                className="text-sm hover:text-soundwave-500 transition-colors"
                style={{ color: 'var(--text-secondary)' }}
              >
                Blog
              </a>
              <a
                href="https://discord.gg/QbUscVer"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-soundwave-500 transition-colors"
                style={{ color: 'var(--text-secondary)' }}
              >
                Discord Support
              </a>
            </div>
          </div>
        </div>

        {/* Bottom: Copyright */}
        <div className="pt-6 border-t" style={{ borderColor: 'var(--border-color)' }}>
          <div className="text-sm text-center" style={{ color: 'var(--text-tertiary)' }}>
            © 2026 PasteWaves. All rights reserved.
            {process.env.REACT_APP_GIT_SHA && (
              <span style={{ opacity: 0.6 }}> ({process.env.REACT_APP_GIT_SHA})</span>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
